import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "bank" }
const _hoisted_3 = ["title"]
const _hoisted_4 = { class: "creep3d" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CurrentDate = _resolveComponent("CurrentDate")!
  const _component_CryptosCreep3d = _resolveComponent("CryptosCreep3d")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, _toDisplayString(_ctx.$t('project2.name')), 1),
    _cache[2] || (_cache[2] = _createElementVNode("line", null, null, -1)),
    _createVNode(_component_CurrentDate),
    _createElementVNode("h1", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.$t('h1')) + " ", 1),
      _cache[1] || (_cache[1] = _createElementVNode("a", {
        href: "https://www.coingecko.com",
        title: "In more detail...",
        target: "_blank"
      }, " CoinGecko ", -1)),
      _createElementVNode("i", {
        title: [_ctx.cripView3d ? 'Close 3D Creeping line' : 'Start 3D Creeping line'],
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeCrip3d && _ctx.changeCrip3d(...args)))
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(['fa', _ctx.cripView3d ? 'fa-yin-yang' : 'fa-bitcoin-sign'])
        }, null, 2)
      ], 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_CryptosCreep3d, { "crip-view3d": _ctx.cripView3d }, null, 8, ["crip-view3d"])
    ])
  ]))
}